export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_26-15f635979fba302bdae9af21cf51fd29.jpg";